export const ru = {
    accept: 'Применить',
    cancel: 'Отмена',
    title: 'Введите логин, либо UID пользователя'
};
